<template>
  <div class="ForgotPassword">
    <div class="background-image"></div>

    <div class="login-card-position">
      <el-card class="box-card">
        <div class="logo-section text-center" @click="goToLink('/')">
          <img src="../assets/images/logo/logo1.png" class="cursor-pointer" style="width: 200px;" />
        </div>

        <div class="top-margin-20">
          <div class="top-margin-15">
            <div class="input-group-section">
              <div class="form-group" :class="{'not-empty': email.length , 'form-group--error':  show_error_on_empty && $v.email.$error }">

                <label class="input-label block bottom-margin-5">EMAIL</label>

                <!-- <input
                  type="text"
                  class="form-control login-custom-input"
                  placeholder
                  name="email"
                  id="email"
                  v-model="email"
                  @input="setEmail($event.target.value)"
                /> -->

                <el-input
                  type="text"
                  class="form-control"
                  name="email"
                  v-model="email"
                  @input="setEmail($event)"
                ></el-input>
              </div>
              <div class="error" v-if="show_error_on_empty && !$v.email.required">Field is required</div>
            </div>
          </div>

          <div class="text-center top-margin-25">
            <el-button rounded class="btn-secondary-theme-filled" style="width: 70%;" v-on:click="sendOtp()" :loading="is_send_otp_btn_loading">SEND OTP</el-button>
          </div>

          <div class="text-center top-margin-10">
            <span style="color: #000; font-size: 0.9rem; font-weight: 300;">Already have an account?</span>&nbsp;
            <span style="color: #000; font-size: 0.9rem; font-weight: 300; border-bottom: 1px solid #000; cursor: pointer;" @click="goToLink('/login')">Login</span>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import { loginNetworkCallBack } from "../mixins/login.NetworkCallback";
import { required, minValue, maxValue } from "vuelidate/lib/validators";

export default {
  name: "ForgotPassword",

  mixins: [loginNetworkCallBack],

  data() {
    return {
      email: "",
      show_error_on_empty: false,
      is_send_otp_btn_loading: false
    };
  },

  validations: {
    email: {
      required
    }
  },

  methods: {
    setEmail(value) {
      this.email = value;
      this.$v.email.$touch();
    },

    sendOtp() {
      this.show_error_on_empty = true;
      this.$v.$touch();

      if (this.email.trim().length) {
        this.is_send_otp_btn_loading = true;

        serverAddr
          .post("/auth/v1/generate_email_otp", {
            email_id: this.email,
            purpose: 'FORGET_PASSWORD'
          })
          .then(this.sendOtpForForgotPasswordNetworkCallBack)
          .catch(function(error) {
            console.log(error);
            this.is_send_otp_btn_loading = false;
          }.bind(this));
      }
    },

    goToLink(link) {
      if(link){
        this.$router.push(link);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.ForgotPassword{
  .background-image {
    background-image: url("../assets/images/login/mobilebg.png");
    height: 100vh;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    opacity: 1;
  }
  .box-card{
    border-radius: 10px;
    margin: 0.4rem;
  }
  .set-password-container {
    margin-top: 20px;
  }
  .login-card-position {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 450px;
  }
  .input-group-section {
    margin-bottom: 16px;
  }

  @media screen and (max-width: 450px) {
    .login-card-position{
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
@import "../css/common.scss";
@import "../css/variable.scss";

.ForgotPassword .el-button.is-loading:before {
  background-color: $primary-theme-color;
  position: relative;
}
.ForgotPassword .el-button .el-icon-loading {
  font-weight: bold;
}
</style>
